import { jsx } from 'react/jsx-runtime';
import { QueryErrorResetBoundary } from '@tanstack/react-query';
import AsyncBoundary from './index.mjs';

function QueryAsyncBoundary({
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx(QueryErrorResetBoundary, { children: ({ reset }) => /* @__PURE__ */ jsx(AsyncBoundary, { onReset: reset, ...props, children }) });
}
QueryAsyncBoundary.ErrorView = AsyncBoundary.ErrorView;

export { QueryAsyncBoundary as default };
//# sourceMappingURL=QueryAsyncBoundary.mjs.map
